export default [
  { segments: ["A-Z", "A-Z"] },
  { segments: ["A-Z", "a-z"] },
  { segments: ["a-z", "a-z"] },
  { segments: ["А-Я", "А-Я"] },
  { segments: ["А-Я", "а-я"] },
  { segments: ["а-я", "а-я"] },
  { segments: ["Α-ΡΣ-Ω", "Α-ΡΣ-Ω"] },
  { segments: ["Α-ΡΣ-Ω", "α-ω"] },
  { segments: ["α-ω", "α-ω"] },
  { segments: ["0-9", "0-9"] },
  { segments: [".,\\-/", "0-9"] },
  { segments: ["@()[]{}", "0-9A-Za-z"] },
  { segments: [".,-", "A-Za-z"] },
  { segments: ["@“”„”„“””\"\"", "A-Za-z"] },
];
